import styled from '@emotion/styled';
import { BottomSheet } from 'react-spring-bottom-sheet';

export const StyledSheetContainer = styled.div`
  padding: ${({ theme }): number => theme.sizes[9]}px;
`;

export const StyledBottomSheet = styled(BottomSheet)`
  [data-rsbs-overlay],
  [data-rsbs-backdrop],
  [data-rsbs-root]:after {
    z-index: ${({ theme }): number => theme.zIndices[8]};
    border-radius: ${({ theme }): string =>
      `${theme.sizes[8]}px ${theme.sizes[8]}px 0 0`};
  }

  /* check is user using Desktop to add mobile fixed view  */
  @media screen and (min-width: 992px), (pointer: fine), (pointer: none) {
    // add max width
    --rsbs-max-w: 580px;
    // make margin left and right auto to centralize it
    --rsbs-ml: auto;
    --rsbs-mr: auto;
    /* default overflow-y scroll to avoid changing width in different browsers  */
    [data-rsbs-scroll] {
      overflow-y: scroll;
    }
  }
`;
